import type { Settings } from '../types'
import { idOf } from './members'

export const defaultSettings: Settings = {
  imeZbora: 'MEPZ VIVA Brežice',
  slogan: 'Vivat, crescat, floreat.',
  pragZelena: 75,
  pragOranzna: 70,
  minDogodkov: 8,
  letoClanarine: 2026,
  znesekClanarine: 60,
  driveLink: 'https://drive.google.com/drive/folders/mepz-viva-gradiva',
  privzetaLokacija: 'Prosvetni dom Brežice, mala dvorana',
  /** Dovoljenje je neodvisno od funkcij v zboru — dodeli se izrecno. */
  dostopOsebnihPodatkov: [idOf('Jelka', 'Žnideršič'), idOf('Ana', 'Žnideršič')],
}
